export default function () {
  this.existsRegister('/v1/professional/steps/staff/status', (data, meta) => {
    if (!data.address && !data.covenant) {
      this.statusAddress = data.address
      this.statusCovenant = data.covenant
      this.show = true
    }
    if (data.address && !data.covenant) {
      this.statusAddress = data.address
      this.statusCovenant = data.covenant
      this.show = true
    }
    if (data.address && data.covenant) {
      this.statusAddress = data.address
      this.statusCovenant = data.covenant
      this.show = false
    }
  })
}



// WEBPACK FOOTER //
// ./src/app/professional/company/staffs/resources/mounted.js